var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v("Nos econtramos bajo mantenimiento. Vuelva a intentarlo más tarde.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }